<template>
  <div class="kris-redaktor-format">
    <rights-docs />
    <akkred />

    <div class="kris-documents-box">
      <div class="h2">Образовательные программы</div>
      <ul class="kris-doclist" v-if="isLoadMet">
        <div class="kris-documents-box">
          <div id="accordion1" class="panel-group">
            <FolderV2 v-bind:key="item.guid" v-for="item in getMetData.folders" :info="item" :folder-name="item.name" parent="0"/>
            <ul v-if="getMetData.files" class="kris-doclist ekis" style="width: 95%;">
              <FileV2 v-bind:key="item.hash" v-for="item in getMetData.files" :info="item"/>
            </ul>
          </div>
        </div>
      </ul>
      <ul v-else>
        <li>Загрузка данных ...</li>
      </ul>
    </div>

    <div class="kris-documents-box">
      <div class="h2">Документы, регламентирующие организацию и осуществление образовательной деятельности, права и обязанности обучающихся</div>
      <ul class="kris-doclist" v-if="isLoadDocs">
        <div class="kris-documents-box" style="margin-left: 45px;">
          <FileV2 v-for="item in data_docs" :info="item"/>
        </div>
      </ul>
      <ul v-else>
        <li>Загрузка данных ...</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FolderV2 from './FolderV2'
import FileV2 from './FileV2'
import RightsDocs from '../components/RightsDocs'
import Akkred from '../components/Accred'
import Axios from "axios";
import _ from "lodash";


export default {
  name: 'DocReview',
  components: {
    FileV2,
    FolderV2,
    'rights-docs': RightsDocs,
    'akkred': Akkred
  },
  data () {
    return {
      isLoadMet: false,
      data_met: false,
      isLoadDocs: false,
      data_docs: false
    }
  },
  computed: {
    ...mapState({
      data: 'dataRightsDocs'
    }),

    getMetData: function () {
      let $this = this
      let roots = [], i, key=0;
      let relatedFiles = []
      roots.push({"folders": [], "files": [], "name": 'root', "hash": key})
      for (i = 0; i < this.data_met.length; i += 1) {
        if (this.data_met[i].doc_location !== '') {
          let m = roots[0];
          let fs = this.data_met[i].doc_location.split('|')
          let item = this.data_met[i]
          if(item.parent_guid === '') {
            _.each(fs, function (v) {
              let folder_name = v.trim().toLowerCase()
              key++
              let k = $this.findInd(m.folders, folder_name);
              if (k === -1)
                k = m.folders.push({"folders": [], "files": [], "name": folder_name, "hash": key}) - 1
              m = m.folders[k]
            })
            m.files.push(this.data_met[i])
          }
        } else {
          roots[0].files.push(this.data_met[i])
        }
      }

      for (i = 0; i < this.data_met.length; i += 1) {
        if (this.data_met[i].doc_location !== '') {
          let m = roots[0];
          let fs = this.data_met[i].doc_location.split('|')
          let item = this.data_met[i]
          if(item.parent_guid !== '') {
            this.data_met[i].path = []
            m = roots[0]
            _.each(fs, function (v) {
              let folder_name = v.trim().toLowerCase()
              let k = $this.findInd(m.folders, folder_name);
              if (k >= 0) {
                m = m.folders[k]
                $this.data_met[i].path.push(k)
              }
            })
            relatedFiles.push(this.data_met[i])
          }
        }
      }

      roots[0].folders = this.attachRelatedFiles(roots[0].folders, relatedFiles)

      this.sortRootFolders(roots[0])
      for(let key in roots[0].folders){
        this.sortFolders(roots[0].folders[key])
      }

      return roots[0]
    }
  },
  created () {
    this.loadDataMet()
    this.loadDocs()
  },

  methods: {
    loadDocs(){
      if (this.isLoadDocs) return
      const path = this.$store.state.apiGo + '/api/v0/files_by_slug/' + this.$store.state.eoId + '?slug=19,17,4,29'
      Axios({
        url: path,
        method: "GET"
      }).then((res) => {
        this.data_docs = res.data.data
        this.isLoadDocs = true;
      }).catch(() => {
        this.data_docs = []
      })
    },
    sortRootFolders(obj){
      let weight = {
        'образовательные программы' : 1,
        'информация о рабочих программах' : 2,
        'учебный план' : 3,
        'календарный учебный график' : 4,
        'методические и иные документы, разработанные образовательной организацией' : 5,
      }
      if(typeof obj.folders !== 'undefined') {
        obj.folders.sort((a, b) => {
          return weight[a.name] - weight[b.name]
        })
      }
    },

    sortFolders(obj){
      let weight = {
        'дошкольное образование' : 1,
        'начальное общее образование' : 2,
        'основное общее образование' : 3,
        'среднее общее образование' : 4,
        '1 класс' : 5,
        '2 класс' : 6,
        '3 класс' : 7,
        '4 класс' : 8,
        '5 класс' : 9,
        '6 класс' : 10,
        '7 класс' : 11,
        '8 класс' : 12,
        '9 класс' : 13,
        '10 класс' : 14,
        '11 класс' : 15,
        'внеурочная деятельность' : 16,
      }

      if(typeof obj.folders !== 'undefined' && obj.folders.length > 0) {
        obj.folders.sort((a, b) => {
          if(weight[a.name] < weight[b.name]){
            return -1
          }
          if(weight[a.name] > weight[b.name]){
            return 1
          }
          return 0
        })
        for(let key in obj.folders){
          this.sortFolders(obj.folders[key])
        }
      }
    },

    loadDataMet() {
      if (this.isLoadMet) return
      const path = this.$store.state.apiGo + '/api/v0/files_by_slug/' + this.$store.state.eoId + '?slug=20&descript=true'
      Axios({
        url: path,
        method: "GET"
      }).then((res) => {
        this.data_met = res.data.data
        this.isLoadMet = true;
      }).catch(() => {
        this.data_met = []
      })
    },

    findInd(mas, name) {
      let i = -1
      _.each(mas, function (v, j) {
        if (v.name == name) {
          i = j
          return
        }
      })
      return i;
    },

    attachRelatedFiles(items, relatedFiles){
      let i = 0
      for (i = 0; i < relatedFiles.length; i += 1) {
        let path = relatedFiles[i].path
        if(typeof relatedFiles[i].path !== 'undefined' && relatedFiles[i].path.length > 0){
          items = this.setElement(items, path, relatedFiles[i])
        }
      }

      return items
    },

    setElement(items, keys, newValue) {
      let k = -1
      switch(keys.length){
        case 1:
          k = this.findInFiles(items[keys[0]].files, newValue.parent_guid)
          if(k >= 0){
            items[keys[0]].files[k].related_file = newValue
          }
          break;
        case 2:
          k = this.findInFiles(items[keys[0]].folders[keys[1]].files, newValue.parent_guid)
          if(k >= 0){
            items[keys[0]].folders[keys[1]].files[k].related_file = newValue
          }
          break;
        case 3:
          k = this.findInFiles(items[keys[0]].folders[keys[1]].folders[keys[2]].files, newValue.parent_guid)
          if(k >= 0){
            items[keys[0]].folders[keys[1]].folders[keys[2]].files[k].related_file = newValue
          }
          break;
        case 4:
          k = this.findInFiles(items[keys[0]].folders[keys[1]].folders[keys[2]].folders[keys[3]].files, newValue.parent_guid)
          if(k >= 0){
            items[keys[0]].folders[keys[1]].folders[keys[2]].folders[keys[3]].files[k].related_file = newValue
          }
          break;
        case 5:
          k = this.findInFiles(items[keys[0]].folders[keys[1]].folders[keys[2]].folders[keys[3]].folders[keys[4]].files, newValue.parent_guid)
          if(k >= 0){
            items[keys[0]].folders[keys[1]].folders[keys[2]].folders[keys[3]].folders[keys[4]].files[k].related_file = newValue
          }
          break;
        case 6:
          k = this.findInFiles(items[keys[0]].folders[keys[1]].folders[keys[2]].folders[keys[3]].folders[keys[4]].folders[keys[5]].files, newValue.parent_guid)
          if(k >= 0){
            items[keys[0]].folders[keys[1]].folders[keys[2]].folders[keys[3]].folders[keys[4]].folders[keys[5]].files[k].related_file = newValue
          }
          break;
      }

      return items
    },

    findInFiles(files, parentGuid){
      let i = 0
      for(i = 0; i < files.length; i += 1 ){
        if(files[i].guid === parentGuid){
          return i
        }
      }
      return -1
    },
  }
}
</script>

<style>
</style>
